import React from 'react';
import { Grid } from '@material-ui/core';
import lifepackXKemenkes from '@/assets/images/lifepackXkemenkes.png';

const LifepackXkemenkesLogo = () => {
  return (
    <Grid
      className="dis-flex py-13"
      style={{
        justifyContent: 'center',
      }}
    >
      <img
        style={{
          width: '65%',
          height: '65%',
        }}
        src={lifepackXKemenkes}
        alt=""
      />
    </Grid>
  );
};

export default LifepackXkemenkesLogo;
